( function ( _s ) {
	const updateUrlParams = newUrlParams => {
		const currPath = window.location.href.split( '?' )[ 0 ];
		const newUrl = currPath + ( newUrlParams.length ? `?${ newUrlParams }` : '' );
		window.history.replaceState( {}, '', newUrl );
	};

	_s.fn.frUrlUpdater = function () {
		return this.each( el => {
			const _self = _s( el );
			const filterIds = JSON.parse( _self.attr( 'filter-ids' ) || '[]' );
			let filtersConfig = {};

			if ( filterIds.length === 0 ) return;

			const selector = [];
			filterIds.forEach( id => {
				selector.push( '#' + id );
			} );
			const _filters = _s( selector.join( ', ' ) );

			if ( _filters.length ) {
				_filters.on( 'fr:filters-changed', e => {
					filtersConfig = { ...filtersConfig, ...e.detail.params };
					//Remove blank attributes from an Object
					const cleanedConfig = Object.fromEntries(
						Object.entries( filtersConfig ).filter( ( [ _, v ] ) => v.length > 0 )
					);
					updateUrlParams( new URLSearchParams( cleanedConfig ).toString() );
				} );
			}
		} );
	};

	_s( document ).ready( () => {
		_s( '[url-updater]' ).frUrlUpdater();
	} );
} )( window._s );
